export const publicAssets = (path: string): string =>
  `https://static.treedis.com/assets/${path}`;
